import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import { brandAdd, brandLoad, brandsLoadAll, brandUpdate } from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(brandAdd.type, send, socket);
  yield takeEvery(brandLoad.type, send, socket);
  yield takeEvery(brandUpdate.type, send, socket);
  yield takeEvery(brandsLoadAll.type, send, socket);
}
